<template>
    <!--グラフ日付パーツ コンテンツ-->

  <v-form
    v-model="validated"
    ref="dateSelectedForm"
    >
    <v-layout row>
      <v-flex xs5>
        <v-dialog
          ref="datePickerDialog"
          persistent
          v-model="showDatepicker"
          lazy
          content-class="datepicker-dialog"
          :disabled="!earliestLogInfo.existsLogAllServices"
          :return-value.sync="toDate"
        >
          <v-text-field
            slot="activator"
            :label="$t('chart.label-date')"
            v-model="formatToDate"
            prepend-icon="event"
            readonly
            :disabled="!earliestLogInfo.existsLogAllServices"
            class="datepicker-field"
          ></v-text-field>
          <v-date-picker v-model="toDate" :min="toDateMin" :max="toDateMax" scrollable
            :title-date-format="date => this.formatDateCommon(date, {month: 'numeric', day: 'numeric'})"
            :header-date-format="date => this.formatDateCommon(date, {year: 'numeric', month: 'numeric'})"
            :month-format="date => this.formatDateCommon(date, {month: 'numeric'})"
            :first-day-of-week=this.firstDayOfWeek()
            :locale=this.locale>
            <v-spacer></v-spacer>
            <v-btn small outline flat
              type="button"
              @click="showDatepicker = false">{{$t("chart.button-cancel")}}</v-btn>
            <v-btn small outline flat
              type="button"
              @click="$refs.datePickerDialog.save(toDate)">{{$t("chart.button-ok")}}</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs4>

        <v-select
          :label="$t('chart.label-time')"
          v-model="toTime"
          :items="toTimes"
          required
          :disabled="!earliestLogInfo.existsLogAllServices"
          auto
        ></v-select>

      </v-flex>
      <v-flex xs8>
        <v-tooltip top :disabled="!showJumpMessagePeriodJump" v-model="showJumpMessagePeriodJump"
          content-class="tooltipMessagePeriodJump">
          <v-btn
            small outline flat
            type="button"
            :color="jumpButtonColor"
            :disabled="disableJump"
            v-on:click="jumpToDate"
            slot="activator">
            {{$t("chart.button-date-jump")}}
          </v-btn>
          <span>{{messagePeriodJump}}</span>
        </v-tooltip>
        <v-btn
          small outline flat
          type="button"
          v-on:click="jumpToRecent">
          {{$t("chart.button-date-recent")}}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <span v-if="messageNoData">{{messageNoData}}</span>
    </v-layout>
  </v-form>
</template>

<script>
// import config from '@/config.js'
import moment from 'moment'
import utils from '@/utils/utils.js'
// import validate from '@/utils/validate.js'

export default {
  props: {
    locale: {
      type: String,
      default: ''
    },
    timezone: {
      type: String,
      default: ''
    },
    messageNoData: {
      type: String,
      default: ''
    },
    messagePeriodJump: {
      type: String,
      default: ''
    },
    earliestLogInfo: Object,
    showJumpMessagePeriodJumpProp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showDatepicker: false,
      toDatetimeUnixTime: null,
      prevToDatetimeUnixTime: null,
      toDateMax: null, // datepickerの最大
      toDate: null,
      toTime: null,
      toTimes: [],
      toDatetime: null,
      validated: true,
      waitingJump: false,
      recentLock: false,
      jumpButtonColor: 'inherit',
      disableJump: false,
      showJumpMessagePeriodJump: false
    }
  },
  watch: {
    toDate: {
      handler: function (newValue, oldValue) {
        this.changeDateTime()
      }
    },
    toTime: {
      handler: function (newValue, oldValue) {
        this.changeDateTime()
      }
    },
    toDatetimeUnixTime: {
      handler: function (newValue, oldValue) {
        this.waitingJump = !this.recentLock && oldValue !== null && newValue !== this.prevToDatetimeUnixTime
        this.jumpButtonColor = this.waitingJump ? 'red' : 'inherit'
        this.recentLock = false
      }
    },
    showJumpMessagePeriodJumpProp: {
      handler: function (newValue, oldValue) {
        this.showJumpMessagePeriodJump = newValue
      }
    }
  },
  computed: {
    /**
     * 移動日フォーマット
     */
    formatToDate: {
      get: function () {
        return this.toDate == null
          ? null : this.formatDateCommon(this.toDate, {year: 'numeric', month: 'numeric', day: 'numeric'})
      },
      set: function (toDate) {
        this.toDate = toDate
      }
    },
    toDateMin: {
      get: function () {
        // console.log(utils.formatDateForDatePickerAndTime(this.earliestLogInfo.earliestTimestamp, this.locale, this.timezone, 'YYYY-MM-DD'))
        return !this.earliestLogInfo.existsLogAllServices
          ? '' : utils.formatDateForDatePickerAndTime(this.earliestLogInfo.earliestTimestamp, this.locale, this.timezone, 'YYYY-MM-DD')
      },
      set: function (toDateMin) {
        this.toDateMin = toDateMin
      }
    }
  },
  beforeMount () {
    // 時刻セレクトボックス生成
    const minutesArr = [0, 15, 30, 45]
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of minutesArr) {
        const timeInnerStr = ('00' + hour).slice(-2) + ':' + ('00' + minute).slice(-2)
        const timeStr = this.formatDateCommon(new Date(1970, 1, 1, hour, minute), {hour: 'numeric', minute: 'numeric'})
        this.toTimes.push({text: timeStr, value: timeInnerStr})
      }
    }
  },
  methods: {
    init () {
    },
    changeSelectDateTime (toDatetimeUnixTime) {
      this.toDatetimeUnixTime = Number(toDatetimeUnixTime)
      // console.log(this.toDatetimeUnixTime)
      // DatePickerの内部で保持している日付形式は-区切りなので一旦'-'に直す
      // utils.dateFormatterだとIE11で日付がY年m月d日となるため、momentを使う
      this.toDate = utils.formatDateForDatePickerAndTime(this.toDatetimeUnixTime, this.locale, this.timezone, 'YYYY-MM-DD')
      this.toDateMax = utils.formatDateForDatePickerAndTime(new Date().getTime(), this.locale, this.timezone, 'YYYY-MM-DD', true)
      this.toTime = utils.formatDateForDatePickerAndTime(this.toDatetimeUnixTime, this.locale, this.timezone, 'HH:mm')
    },
    changeDateTime () {
      this.toDatetimeUnixTime = utils.getDateTimeUnixTimestamp(this.toDate, this.toTime)
      this.$emit('changeDatetime', this.toDatetimeUnixTime)
    },
    jumpToDate () {
      this.waitingJump = false
      this.jumpButtonColor = 'inherit'
      this.prevToDatetimeUnixTime = this.toDatetimeUnixTime
      // ラジオボタン、セレクトボックスの値からUNIXタイムスタンプ取得
      // console.log(this.toDatetimeUnixTime)
      // 指定した日付にジャンプ
      this.$emit('jumpToDatetime', this.toDatetimeUnixTime)
    },
    jumpToRecent () {
      this.waitingJump = false
      this.recentLock = true
      this.jumpButtonColor = 'inherit'
      // UNIXタイムスタンプ取得
      this.toDatetimeUnixTime = Math.floor(Date.now() / 1000)
      this.toDatetimeUnixTime = this.toDatetimeUnixTime - (this.toDatetimeUnixTime % (15 * 60))
      this.prevToDatetimeUnixTime = this.toDatetimeUnixTime
      this.changeSelectDateTime(this.toDatetimeUnixTime)
      this.$emit('jumpToRecent', this.toDatetimeUnixTime)
    },
    resetWaitingJump () {
      this.waitingJump = false
      this.jumpButtonColor = 'inherit'
    },
    setDisableJump (disableJump) {
      this.disableJump = disableJump
    },
    /**
     * 日付をフォーマットする
     */
    formatDateCommon (date, dateOptions) {
      dateOptions.timezone = this.timezone
      return utils.dateFormatter(this.locale, moment(date).unix() * 1000, dateOptions)
    },
    /**
     * カレンダーの週の開始曜日を設定する
     */
    firstDayOfWeek () {
      return utils.firstDayOfWeek(this.locale)
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.dialog__container {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// GraphDateSelect.vue?5e70060d